import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// @mui
// redux
import useAuth from 'src/hooks/useAuth';
import { useDispatch } from 'src/redux/store';
// routes
// hooks
// components
import MainIntegracoes from 'src/sections/@dashboard/configuracoes/Integracoes/MainIntegracoes';

//paginas
import { verifyRules } from 'src/utils/functions';
import { CanaisComponent } from 'src/sections/@dashboard/configuracoes/canais';
import UsuariosComponent from 'src/sections/@dashboard/configuracoes/usuarios';
import RespostasRapidasComponent from 'src/sections/@dashboard/configuracoes/respostasRapidas';
import TagsComponent from 'src/sections/@dashboard/configuracoes/tags';
import ApisComponent from 'src/sections/@dashboard/configuracoes/apis';

import actionListaCanaisPorCliente from 'src/actions/clientes/actionListaCanaisPorCliente';
import ModalAlerta from 'src/components/modal/ModalAlerta';
import FunilComponent from 'src/sections/@dashboard/configuracoes/funil';
import v1_actionListaAutomacoes from 'src/actions/v1/clientes/v1_actionListaAutomacoes';
import FlowsComponent from 'src/sections/@dashboard/configuracoes/flows/FlowsComponent';
import FlowDetails from 'src/sections/@dashboard/configuracoes/flows/FlowDetails';
import v1_actionListaFlows from 'src/actions/v1/clientes/v1_actionListaFlows';
import CanaisDetails from 'src/sections/@dashboard/configuracoes/canais/CanaisDetails';
import { useLocation } from 'react-router-dom'; // se estiver usando react-router
import CanaisMetaPageList from 'src/sections/@dashboard/configuracoes/canais/CanaisMetaPageList';
import SetoresComponent from 'src/sections/@dashboard/configuracoes/setores';
import ConectarWhatsapp from 'src/sections/@dashboard/configuracoes/canais/ConectarWhatsapp';
import PerfilComponent from "src/sections/@dashboard/configuracoes/perfil"
import SidebarDashboard from "src/sections/@dashboard/SidebarDashboard"
import CredenciaisComponent from "src/sections/@dashboard/configuracoes/credenciais"
import { AgentesIaComponent } from "src/sections/@dashboard/configuracoes/agentesIa"
import ConfigAgentesIaComponent from "src/sections/@dashboard/configuracoes/agentesIa/ConfigAgentesIaComponent"
import v2_actionListaAgentesAi from "src/actions/v2/ai/v2_actionListaAgentesAi"
import { useSnackbar } from "notistack"
import BaseDadosAi from "src/sections/@dashboard/configuracoes/baseDadosAi"
import DocumentStoreDetails from "src/sections/@dashboard/configuracoes/agentesIa/components/training/views/DocumentStoreDetail"
import AiVozesComponent from "src/sections/@dashboard/configuracoes/aiVozes"
import Automacoes from "src/sections/@dashboard/configuracoes/automacoes/Automacoes"
import { getConfig } from "src/redux/slices/global"
import Copilot from "src/sections/@dashboard/configuracoes/Integracoes/Copilot"
import DirecionamentosComponent from 'src/sections/@dashboard/configuracoes/direcionamentos';
import Google from 'src/sections/@dashboard/configuracoes/Integracoes/Google';
import Make from 'src/sections/@dashboard/configuracoes/Integracoes/Make';
import CalendariosConfig from 'src/sections/@dashboard/configuracoes/calendario';
import CalendarioConfig from 'src/sections/@dashboard/configuracoes/calendario/Calendario';
import ServicosComponent from 'src/sections/@dashboard/configuracoes/cadastro/servicos';
import ProdutosComponent from 'src/sections/@dashboard/configuracoes/cadastro/produtos';
import AgenteAiDetails from 'src/sections/@dashboard/configuracoes/agentesIa/AgenteAiDetails';
import ModulosConfig from 'src/sections/@dashboard/configuracoes/modulos';
import AnaliseAtendimento from 'src/sections/@dashboard/configuracoes/modulos/AnaliseAtendimento';
import Autocomplete from 'src/sections/@dashboard/configuracoes/modulos/Autocomplete';
import EditarProduto from 'src/sections/@dashboard/configuracoes/cadastro/produtos/EditarProduto';
import TemplatesWhatsappPage from 'src/sections/@dashboard/configuracoes/templates-whatsapp';
import TemplatesCategoryLogs from 'src/sections/@dashboard/configuracoes/templates-whatsapp/TemplatesCategoryLogs';
import TriggersComponent from 'src/sections/@dashboard/configuracoes/triggers/TriggersComponent';
import FacebookConnectPage from 'src/sections/@dashboard/configuracoes/canais/FacebookConnectPage';
import ChatbotList from 'src/sections/@dashboard/configuracoes/chatbots/ChatbotList';
import ChamadosConfigComponent from 'src/sections/@dashboard/configuracoes/chamados-config';
import TarefasConfigComponent from 'src/sections/@dashboard/configuracoes/tarefas-config';
import PluginsComponent from 'src/sections/@dashboard/configuracoes/plugins';



export default function Configuracoes() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, cliente } = useAuth()
  const { label } = useParams();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [listaCanais, setCanais] = useState([]);
  const [listaFlows, setListaFlows] = useState([]);
  const [listaAutomacoes, setListaAutomacoes] = useState([]);
  const [modalAlerta, setModalAlerta] = useState(false);
  const [msgModalAlerta, setMsgModalAlerta] = useState("");
  const [flow, setFlow] = useState(null);
  const [canaisError, setCanaisError] = useState(null);

  const [listaAgentesAi, setListaAgentesAi] = useState([]);

  const location = useLocation();
  let path = location.pathname.substring(1); // Remove o "/" inicial


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('channelId');

  }, [location]);

  const buscarListaAutomacoes = async () => {
    try {

      const response = await v1_actionListaAutomacoes(cliente._id)
      setListaAutomacoes(response.data.data);

    } catch (error) {

    }
  }

  async function buscarListaAgentesAi() {
    try {
      const response = await v2_actionListaAgentesAi(cliente._id);
      if (response.status !== 200) return enqueueSnackbar("Erro ao buscar lista de agentes de IA", { variant: 'error' });
      setListaAgentesAi(response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const buscarListaCanais = async () => {
    try {
      setCanaisError(null)
      const response = await actionListaCanaisPorCliente(cliente._id)
      setCanais(response.data.data)
    } catch (error) {
      console.error('Erro ao buscar canais:', error)
      setCanaisError("Erro ao buscar lista de canais. Verifique sua conexão e tente novamente.")
      setMsgModalAlerta("Erro ao buscar lista de canais, tente novamente mais tarde. Se persistir entre em contato com o suporte.")
      setModalAlerta(true)
    }
  }


  const buscarListaFlows = async () => {
    try {
      const response = await v1_actionListaFlows(cliente._id)
      setListaFlows(response.data.data)
    } catch (error) {
      setMsgModalAlerta("Erro ao buscar lista de canais, tente novamente mais tarde. Se persistir entre em contato com o suporte.")
      setModalAlerta(true)
    }
  }

  // eslint-disable-next-line no-unused-vars

  const linkTo = (label) => {
    return `/dashboard/configuracoes/${label}`;

  };


  function abrirOutraPagina(canal) {
    window.open(`https://www.facebook.com/v20.0/dialog/oauth?client_id=1130925304811273&state=${canal._id}&redirect_uri=https://webhook-beta.lais.app/webhook/v1/auth&scope=instagram_basic,instagram_manage_messages`, '_blank');
  }

  useEffect(() => {

    buscarListaCanais();
    buscarListaAutomacoes();
    buscarListaFlows();
    buscarListaAgentesAi();
    dispatch(getConfig());

  }, [dispatch]);





  return (
    <>
      <ModalAlerta
        open={modalAlerta}
        mensagem={msgModalAlerta}
        onClose={() => setModalAlerta(false)}
      />
      <div className="flex h-full w-full overflow-hidden">
        <SidebarDashboard user={user} />

        <main className="flex-1 flex flex-col h-full overflow-hidden relative w-full">
          <div className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8 w-full scrollbar-thin scrollbar-thumb-gray-200">
            <div className="mx-auto max-w-[1600px] w-full animate-in fade-in slide-in-from-bottom-4 duration-500">

              {label === "canais" && <CanaisComponent
                user={user}
                cliente={cliente}
                listaCanais={listaCanais}
                canaisError={canaisError}
                onButtonLoginFacebook={canal => abrirOutraPagina(canal)}
                onCallback={() => buscarListaCanais()}
                onConfig={item => {
                  setFlow(item);
                  navigate(linkTo('channelDetails'))
                }}
              />}
              {label === "flows" && <FlowsComponent
                user={user}
                cliente={cliente}
                onCallback={() => buscarListaFlows()}
                onConfigFlow={item => {
                  setFlow(item);
                  navigate(linkTo('flowDetails'))
                }}
                list={listaFlows} />
              }
              {label === "perfil" && <PerfilComponent cliente={cliente} />}
              {label === "integracoes" && <MainIntegracoes cliente={cliente} />}

              {label === "copilot" && <Copilot cliente={cliente} />}
              {label === "google" && <Google cliente={cliente} />}
              {label === "make" && <Make cliente={cliente} />}

              {label === "conectar-whatsapp" && <ConectarWhatsapp />}
              {verifyRules(user.rules, "agentes") && label === "usuarios" && <UsuariosComponent user={user} />}
              {verifyRules(user.rules, "respostas_rapidas") && label === "respostas-rapidas" && <RespostasRapidasComponent />}
              {label === "funil-vendas" && <FunilComponent user={user} cliente={cliente} />}
              {/* {label === "automacoes" && <MainAutomacoes onCallback={buscarListaAutomacoes} cliente={cliente} user={user} listaAutomacoes={listaAutomacoes} />} */}

              {label === "tags" && <TagsComponent />}
              {label === "apis" && <ApisComponent />}
              {label === "direcionamentos" && <DirecionamentosComponent />}
              {label === "setores" && <SetoresComponent />}
              {label === "flowDetails" && <FlowDetails flow={flow} user={user} cliente={cliente} />}
              {label === "channelDetails" && <CanaisDetails dispatch={dispatch} flow={flow} user={user} cliente={cliente} />}
              {label === "pageList" && <CanaisMetaPageList flow={flow} user={user} cliente={cliente} />}
              {label === "credenciais" && <CredenciaisComponent flow={flow} user={user} cliente={cliente} />}
              {label === "aiDatabases" && <BaseDadosAi user={user} cliente={cliente} />}
              {label === "aiDatabaseDetail" && <DocumentStoreDetails user={user} cliente={cliente} />}
              {label === "agentes-ia" && <AgentesIaComponent list={listaAgentesAi} flow={flow} user={user} cliente={cliente} />}
              {label === "agentOnboarding" && <ConfigAgentesIaComponent flow={flow} user={user} cliente={cliente} />}
              {label === "agentDetail" && <AgenteAiDetails flow={flow} user={user} cliente={cliente} />}
              {label === "aiVoices" && <AiVozesComponent flow={flow} user={user} cliente={cliente} />}
              {label === "calendario" && <CalendarioConfig user={user} onCallback={() => { }} />}
              {label === "calendarios" && <CalendariosConfig user={user} onCallback={() => { }} />}
              {label === "servicos" && <ServicosComponent user={user} cliente={cliente} />}
              {label === "produtos" && <ProdutosComponent user={user} cliente={cliente} />}
              {label === "editar-produto" && <EditarProduto user={user} cliente={cliente} />}
              {label === "modulos" && <ModulosConfig user={user} />}
              {label === "analise-atendimento" && <AnaliseAtendimento user={user} cliente={cliente} />}
              {label === "autocompletar" && <Autocomplete user={user} cliente={cliente} />}
              {label === "templates-whatsapp" && <TemplatesWhatsappPage />}
              {label === "templates-category-logs" && <TemplatesCategoryLogs />}
              {label === "triggers" && <TriggersComponent />}
              {label === "facebook-connect" && <FacebookConnectPage />}
              {label === "chatbots" && <ChatbotList />}
              {label === "chamados-config" && <ChamadosConfigComponent />}
              {label === "tarefas-config" && <TarefasConfigComponent />}
              {label === "plugins" && <PluginsComponent />}


            </div>
          </div>
        </main>
      </div>
    </>
  )
}
